import { render, staticRenderFns } from "./recordCertificate.vue?vue&type=template&id=650ce232&scoped=true"
import script from "./recordCertificate.vue?vue&type=script&lang=js"
export * from "./recordCertificate.vue?vue&type=script&lang=js"
import style0 from "./recordCertificate.vue?vue&type=style&index=0&id=650ce232&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650ce232",
  null
  
)

export default component.exports